
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.5 12.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.22.22a.75.75 0 011.133.977l-.073.084-11 11a.75.75 0 01-.977.073l-.083-.074-5-5a.75.75 0 01.98-1.133l.084.073 4.47 4.469z","fill":"#4ca198","data-name":"Icons / check-2"}})])
          )
        }
      }
    